import { Button, Card, CardActions, CardContent, Chip, Divider, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { WeekLongString } from "../../Helper/Week";
import { PackChargeTypeStrings, StudioPack } from "../../Objects/StudioPack";
import LabelItem from "../atoms/LabelItem";

export interface StudioPackCardProps {
    studioPack: StudioPack
    onDelete?: () => void
    onEdit?: () => void
}

const StudioPackCard: React.FC<StudioPackCardProps> = ({
    studioPack,
    onDelete,
    onEdit,
}) => {
    let pack_rvtiming: string = "";
    if (studioPack.pack_rvtiming_start) {
        pack_rvtiming += `${studioPack.pack_rvtiming_start}日前から`
    }
    if (studioPack.pack_rvtiming_end) {
        pack_rvtiming += `${studioPack.pack_rvtiming_end}日前まで`
    }
    if (pack_rvtiming !== "") {
        pack_rvtiming = `予約日${pack_rvtiming}の予約で適用`
    }
    let pack_rvdate: string = "";
    if (studioPack.pack_rvdate_start) {
        pack_rvdate += `${format(studioPack.pack_rvdate_start, "yyyy年MM月dd日")}以降`
    }
    if (studioPack.pack_rvdate_end) {
        pack_rvdate += `${format(studioPack.pack_rvdate_end, "yyyy年MM月dd日")}まで`
    }
    if (pack_rvdate !== "") {
        pack_rvdate = `${pack_rvdate}の予約で有効`
    }
    let pack_rvtime: string = "";
    if (studioPack.pack_rvtime_start) {
        pack_rvtime += ` ${studioPack.pack_rvtime_start.toStringHMJP()} 以降`
    }
    if (studioPack.pack_rvtime_end) {
        pack_rvtime += ` ${studioPack.pack_rvtime_end.toStringHMJP()} まで`
    }
    if (pack_rvtime !== "") {
        pack_rvtime = `${pack_rvtime}の予約で有効`
    }
    return (
        <Card>
            <CardContent>
                <Stack
                    spacing={0.5}
                >
                    <Typography>[{studioPack.pack_std_name}] {studioPack.pack_name}</Typography>
                    <Divider />
                    <LabelItem
                        title="適用曜日"
                    >{studioPack.week_conditions && studioPack.week_conditions.map((week, index) => (<Chip key={index} label={WeekLongString[week]} />))}</LabelItem>
                    <LabelItem
                        title="適用スタジオ"
                    >{studioPack.pack_std_name}</LabelItem>
                    <LabelItem
                        title="適用予約タイミング"
                    >{pack_rvtiming ? pack_rvtiming : "設定なし"}</LabelItem>
                    <LabelItem
                        title="設定適用期間"
                    >{pack_rvdate ? pack_rvdate : "設定なし"}</LabelItem>
                    <LabelItem
                        title="設定適用時間帯"
                    >{pack_rvtime ? pack_rvtime : "設定なし"}</LabelItem>
                    <LabelItem
                        title="適用コマ数"
                    >{studioPack.pack_unit_length ? `${studioPack.pack_unit_length}コマ` : "設定なし"}</LabelItem>
                    <LabelItem
                        title="適用料金カテゴリ"
                    >{studioPack.chrcate_name ? studioPack.chrcate_name : "設定なし"}</LabelItem>
                    <LabelItem
                        title="パック料金"
                    >{(studioPack.pack_charge !== undefined && studioPack.pack_charge_type !== undefined) ? `${studioPack.pack_charge.toLocaleString()} ${PackChargeTypeStrings[studioPack.pack_charge_type]}` : "設定なし"}</LabelItem>
                    <LabelItem
                        title="適用優先度"
                    >{(studioPack.priority !== undefined) ? `${studioPack.priority.toLocaleString()}` : "設定なし"}</LabelItem>
                </Stack>
            </CardContent>
            <CardActions>
                <Stack
                    sx={{
                        m: 1,
                        width: "100%"
                    }}
                    justifyContent="right"
                    direction="row"
                    spacing={2}
                >
                    {onEdit &&
                        <Button
                            variant="outlined"
                            onClick={() => {
                                onEdit()
                            }}
                        >編集</Button>
                    }
                    {onDelete &&
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={() => {
                                onDelete()
                            }}
                        >削除</Button>
                    }
                </Stack>
            </CardActions>
        </Card>
    )
}

export default StudioPackCard;